import { render } from "./listSection.vue?vue&type=template&id=465643ce&scoped=true"
import script from "./listSection.vue?vue&type=script&lang=js"
export * from "./listSection.vue?vue&type=script&lang=js"

import "./listSection.vue?vue&type=style&index=0&id=465643ce&scoped=true&lang=css"

import exportComponent from "D:\\code\\csxlib-digital-resource\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465643ce"]])

export default __exports__